import { Injectable } from "@angular/core";
import { BfxBlotterAction } from "shared/cubiq-services";
import { Observable, Subject } from "rxjs";

import { BfxDialogData } from "../bfx-dialogs/models/bfx-dialog-data.model";
import { BfxDialogCommand } from "../bfx-dialogs/models/bfx-dialog-command.enum";
import { BfxFindNewFavoriteActionEvent } from "../bfx-find/models/BfxFindNewFavoriteActionEvent";
import { BfxBlotterActionEvent } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBaseBlotter } from "../bfx-base-blotter/bfx-base-blotter";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxFindService {
  protected blotterName: string = "find";

  protected filterViewResponseSubject = new Subject();
  protected filterViewRequestSubject = new Subject<void>();
  protected clearRequestSubject = new Subject<void>();
  protected cellCloseNotificationSubject = new Subject<void>();
  protected findActionSubscription = new Subject<BfxDialogData>();
  public dialogCtrl$ = this.findActionSubscription.asObservable();

  constructor() {}

  public createNewFavorite(callback: Function, favoriteNames: Set<string> = new Set()): any {
    this.findActionSubscription.next(
      new BfxDialogData(
        BfxDialogCommand.DIALOG_FIND_NEW_FAVORITE,
        null,
        new BfxFindNewFavoriteActionEvent(callback, true, null),
        { favoriteNames: favoriteNames },
      ),
    );
  }

  public getClearRequestSubject(): Observable<any> {
    return this.clearRequestSubject.asObservable();
  }

  public getFilterViewResponseObservable(): Observable<any> {
    return this.filterViewResponseSubject.asObservable();
  }

  public getFilterRequestObservable(): Observable<any> {
    return this.filterViewRequestSubject.asObservable();
  }

  public getCellCloseNotificationSubject(): Observable<any> {
    return this.cellCloseNotificationSubject.asObservable();
  }

  public requestClear(): void {
    this.clearRequestSubject.next();
  }

  public requestExport(blotter: BfxBaseBlotter): void {
    let selectedItems: any[] = [];
    let selectedIds: string[] = [];
    if (blotter != null) {
      selectedItems = blotter.getSelectedTableRows();
      let tableKey = blotter.tableDefinition.hasOverwriteKey()
        ? blotter.tableDefinition.overwriteKey
        : blotter.tableDefinition.primaryKey;
      selectedItems.forEach((order) => selectedIds.push(order[tableKey].toString()));
    }
    this.findActionSubscription.next(
      new BfxDialogData(
        BfxDialogCommand.DIALOG_CSV_EXPORT_OPEN,
        null,
        new BfxBlotterActionEvent(
          BfxBlotterAction.ACTION_EXPORT,
          blotter,
          selectedIds,
          selectedItems,
        ),
        {
          blotterName: this.blotterName,
        },
      ),
    );
  }

  public requestFilterView(): void {
    this.filterViewRequestSubject.next();
  }

  public responseFilterView(data: any) {
    this.filterViewResponseSubject.next(data);
  }

  public notifyCellClose(): void {
    this.cellCloseNotificationSubject.next();
  }

  public setBlotterName(blotterName: string) {
    this.blotterName = blotterName;
  }
}
